import { initializeApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAhT1UbSsE8CSleGqzDd3cg7ivD-zUTBnc",
  authDomain: "spor-haritasi.firebaseapp.com",
  projectId: "spor-haritasi",
  storageBucket: "spor-haritasi.firebasestorage.app",
  messagingSenderId: "480940044998",
  appId: "1:480940044998:web:b2d6e21dc6dfc81a735dc7"
};

// Initialize Firebase (singleton pattern)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);

// Set language to Turkish
auth.languageCode = 'tr';

// Messaging instance (lazy loaded)
let messagingInstance = null;

export const getMessagingInstance = () => {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window) {
    if (!messagingInstance) {
      try {
        messagingInstance = getMessaging(app);
      } catch (error) {
        console.error('Error initializing Firebase messaging:', error);
      }
    }
  }
  return messagingInstance;
};

// VAPID key - Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (!('Notification' in window)) {
      console.log('Bu tarayıcı bildirimleri desteklemiyor');
      return null;
    }

    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const messaging = getMessagingInstance();
      if (!messaging) {
        console.error('Mesajlaşma servisi kullanılamıyor');
        return null;
      }

      // Register service worker
      let registration;
      try {
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log('Service worker registered');
      } catch (swError) {
        console.error('Service worker registration failed:', swError);
        return null;
      }
      
      // Get FCM token
      if (VAPID_KEY) {
        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: registration
        });
        console.log('FCM Token alındı');
        return token;
      } else {
        console.warn('VAPID key tanımlı değil - push bildirimleri çalışmayacak');
        return null;
      }
    } else {
      console.log('Bildirim izni reddedildi');
      return null;
    }
  } catch (error) {
    console.error('Bildirim izni alınırken hata:', error);
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  const messaging = getMessagingInstance();
  if (messaging) {
    return onMessage(messaging, (payload) => {
      console.log('Ön plan mesajı alındı:', payload);
      callback(payload);
    });
  }
  return () => {};
};

export { auth, RecaptchaVerifier, signInWithPhoneNumber, getToken, onMessage };
export default app;
